exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6f0adf46] .v-datatable.v-table>thead{display:table-row-group}[data-v-6f0adf46] .v-datatable.v-table>tbody{max-height:40vh;min-height:40vh;overflow-y:auto;overflow-x:auto;display:table-row-group}", ""]);

// exports
